import { Component } from '@angular/core';

@Component({
  selector: 'oes-theme-a2ei',
  templateUrl: './a2ei.component.html',
  styleUrls: ['./a2ei.component.scss']
})
export class A2eiComponent {

  constructor() { }

}
